module.exports = __webpack_public_path__ + "static/img/kuaisu.f2f8d14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/kuaisu.png
// module id = KnMU
// module chunks = 70